<template>
  <div>
    <v-container v-if="loadingFormulario">
      <v-progress-circular indeterminate color="green"></v-progress-circular>
    </v-container>
    <div v-else class="p-4 container">
      <div class="row">
        <div class="col-lg-10">
          <h5 class="NomePacienteAtual text-left">
            Tutor: {{ paciente.NomeTutor }} <br />Pet: {{ paciente.NomePet }}
          </h5>
        </div>
        <div class="col-lg-2">
          <!-- <div class="d-flex justify-content-between align-items-center">
            <label class="mr-2">Data: </label>
            <v-text-field
              clear-icon="clear"
              style="margin: 0 5px; padding-top: 5px !important"
              :type="'date'"
              :outlined="false"
              v-model="DataHoje"
            />
          </div> -->
          <h5 class="mr-2">Data: {{ getDate(DataHoje) }}</h5>
        </div>
        <div v-if="false" class="d-flex flex-column col-12">
          <label for=""><strong>Título</strong></label>
          <v-text-field
            v-model="form_resp.titulo"
            placeholder="Ex: Consulta Básica"
            required
            class="col-6 m-auto"
          ></v-text-field>
        </div>
        <div v-if="false" class="d-flex flex-column col-12">
          <label for=""><strong>Observação</strong></label>
          <v-text-field
            v-model="form_resp.descricao"
            placeholder="Ex: Formulário para uma primeira consulta"
            required
            class="col-6 m-auto"
          ></v-text-field>
        </div>
        <div
          :class="input.id_tipo_pergunta !== 2 ? 'col-lg-4' : 'col-lg-6'"
          v-for="(input, index) in form.perguntas"
          :key="`pergunta${index}`"
        >
          <div class="col-12 d-flex justify-center">
            <form-consulta-fill
              :pergunta="input"
              v-if="input"
              @resposta="respondido($event)"
              class="col-12"
            />
          </div>
        </div>
      </div>
      <v-divider></v-divider>
      <div class="obito d-flex align-items-center" v-if="perfilObito">
        <span class="me-2">Esse pet veio a óbito?</span>
        <v-checkbox
            v-model="checkObito"
            color="rgb(62, 104, 42)"
            class="ma-0 pa-0 checkboxObito"
            style="margin-top: 0 !important; margin-bottom: 0 !important;"
            dense
            hide-details
        ></v-checkbox>
      </div>
      <div v-if="checkObito">
        <h3 class="d-flex font-weight-black">Sobre o óbito</h3>

            <div class="container pt-6">
              <div class="row">
                <div class="col-6">

                  <v-select
                      v-model="procedimentoSelected"
                      label="Tipos óbito"
                      :items="procedimentoList"
                      item-text="text"
                      item-value="value"
                      hide-details
                  ></v-select>
                </div>
                <div class="col-3">
                  <v-text-field
                      v-model="data_obito"
                      label="Data de óbito"
                      type="date"
                      hide-details
                      :min="DataHoje"
                      class="mb-3"
                  />
                </div>
                <div class="col-3">
                  <v-text-field
                      v-model="hora_obito"
                      label="Hora de óbito"
                      hide-details
                      type="time"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <v-textarea v-model="obs_obito" label="Observação"></v-textarea>
                </div>
              </div>
            </div>
      </div>
      <v-divider></v-divider>
      <div class="row">
        <div class="col-md-12 text-right d-flex justify-lg-space-between">
          <button
            class="btn btn-cancelar btn-padding font-weight-bold"
            @click="fecharModal"
          >
            Cancelar
          </button>

          <button
            class="btn btn-app-primary btn-padding font-weight-bold"
            @click="salvarConsulta"
            :disabled="validForm()"
          >
            <span v-if="!loading"> Salvar </span>
            <v-progress-circular
              v-else
              indeterminate
              color="white"
            ></v-progress-circular>
          </button>
        </div>
      </div>
      <v-spacer></v-spacer>
      <br>

    </div>
  </div>
</template>

<script>
import FormularioService from "@/services/formulario_service.js";
import ConsultaService from "@/services/consulta_service.js";
import FormConsultaFill from "@/components/consultas/formulario_consulta_fill.vue";
import Mixin from "@/mixins/vuex_mixin.js";
import ObitoService from "@/services/obito_service";
export default {
  mixins: [Mixin],
  props: {
    paciente: Object,
    info: Object,
    idRequisicao: String,
    idFormulario: String,
  },
  components: {
    FormConsultaFill,
  },
  async beforeMount() {
    this.unidadeId = await JSON.parse(sessionStorage.getItem("vuex")).unidade
        .id;
    this.perfil = await JSON.parse(sessionStorage.getItem("vuex")).perfil
        .id;
    console.log('o perfil desse usuario é', this.perfil)
    console.log(this.paciente.PetCodigo)
    console.log(this.unidadeId)
    this.form_resp.id_agendamento = this.info.idAgendamento;
    // this.form_resp.id_formulario = this.info.idFormulario;
    this.form_resp.id_formulario = this.idFormulario;
    this.loadingForm();
  },

  data: () => ({
    //Iniciar consulta
    services: {
      obitoService: ObitoService.build(),
    },
    dialog: false,
    loading: false,
    perfil: 0,
    perfilObito: false,
    procedimentoList: [],
    procedimentoSelected: "",
    data_obito: null,
    hora_obito: "",
    obs_obito: "",
    unidadeId: 0,
    loaded: false,
    loadingFormulario: false,
    form: {},
    resp: [],
    checkObito: false,
    form_resp: {
      id_formulario: 0,
      id_agendamento: 0,
      titulo: "",
      descricao: "",
      respostas: [],
      id_requisicao_procedimento: 0,
      obito: {},
    },
    //Dados form
    DataHoje: new Date().toISOString().substr(0, 10),

    //Checkboxes forms opcionais
    checkboxAnamnese: false,
    checkboxGestacao: false,
    checkboxExamefisico: false,
    checkboxCirugiaPrevista: false,
    checkboxMateriaisEspeciais: false,
  }),
  watch: {
    perfil(){
      if (this.perfil === 2 || this.perfil === 1) {
        this.perfilObito = true;
        return;
      }
      this.perfilObito = false;
    },
    idFormulario() {
      this.loadingForm();
    },
    loaded() {
      if (this.loadingForm && this.form.perguntas) {
        this.loaded = true;
      }
    },
  },
  async mounted() {
    this.unidadeId = await JSON.parse(sessionStorage.getItem("vuex")).unidade
        .id;
    this.getListProcedimentosObito();
    this.petId = this.paciente.PetCodigo;
    console.log(this.petId)
    console.log(this.procedimentoList)
  },
  methods: {
    model() {
      return {
        obito: this.checkObito ? 's' : 'n',
        id_pet: this.petId,
        id_convenio_procedimento: this.procedimentoSelected,
        data_execucao: this.data_obito,
        hora_execucao: this.hora_obito,
        id_unidade: this.unidadeId,
        observacao: this.obs_obito,
      };
    },
    validForm() {
      if(!this.checkObito){
        this.procedimentoSelected = "";
        this.data_obito = new Date().toISOString().substr(0, 10);
        this.hora_obito = "";
        this.obs_obito = ""
        return false;
      }
      return this.petId > 0 &&
      this.procedimentoSelected != "" &&
      this.data_obito != "" &&
      this.hora_obito != "" &&
      this.unidadeId > 0
          ? false
          : true;
    },
    getListProcedimentosObito() {
      this.data_obito = new Date().toISOString().substr(0, 10);
      console.log('testandoadata aqui : ',new Date().toISOString().substr(0, 10))
      this.services.obitoService
          .procedimentosObitoUnidade(this.unidadeId)
          .then(async (response) => {
            console.log("response", response);
            if (response.status !== 200) return;
            const { data } = await response.json();
            let list = [];
            for (let index = 0; index < data[0].length; index++) {
              const element = data[0][index];
              list.push({
                value: element.id,
                text: element.procedimento,
              });
            }
            this.procedimentoList = list;
          })
          .catch((err) => {
            console.error(err);
          })
          .finally(() => {
            // this.loading = false;
          });
    },
    respondido(e) {
      if (this.resp.length < 1) {
        this.resp.push({ id_pergunta: e.id_pergunta, resposta: e.resposta });
      } else {
        let respEvent = this.resp
          .map((p) => p.id_pergunta)
          .indexOf(e.id_pergunta);
        if (respEvent >= 0) {
          this.resp[respEvent] = {
            id_pergunta: e.id_pergunta,
            resposta: e.resposta,
          };
        } else {
          this.resp.push({ id_pergunta: e.id_pergunta, resposta: e.resposta });
        }
      }
    },
    check: function(e) {
      e.cancelBubble = true;
      console.log("checkbox checked");
    },
    expansionPanel: function() {
      console.log("expansion panel");
    },

    fecharModal() {
      this.$emit("close");
    },

    salvarConsulta() {
      if (this.form_resp.titulo == "") {
        // this.$_ACTIONS_showSnackbarMessage({
        //   message:"O campo Título é obrigatorio",
        //   color: "error",
        // });
        // return;
        this.form_resp.titulo = "titulo";
      }
      if (this.form_resp.descricao == "") {
        // this.$_ACTIONS_showSnackbarMessage({
        //   message: "O campo Descrição é obrigatorio",
        //     color: "error",
        //   });
        // return;
        this.form_resp.descricao = "descricao";
      }
      if (parseInt(this.data_obito.slice(0,4)) <= 1980){
        this.$_ACTIONS_showSnackbarMessage({
          message: "Data inválida!",
          color: "error",
        });
        return;
      }
      if (parseInt(this.data_obito.slice(0,4)) <= 1980){
        this.$_ACTIONS_showSnackbarMessage({
          message: "Data inválida!",
          color: "error",
        });
        return;
      }
      console.log('Data do obito verify: ', this.data_obito.slice(0,4))
      // this.form_resp.id_formulario = this.info.idFormulario;
      let model = this.model();
      this.form_resp.obito = model;
      this.form_resp.id_formulario = this.idFormulario;
      this.form_resp.respostas = this.resp;
      this.form_resp.id_requisicao_procedimento = this.idRequisicao;
      const consultaService = new ConsultaService();
      consultaService.register(
        {
          onSucess: (status) => (body) => {
            console.log('status obt', status)
            console.log('body obt', body)
            if (status === 200) {
              // if(this.checkObito){
              //   this.$emit('obito', 's')
              //   localStorage.setItem('obito', 's')
              // }
              // else localStorage.removeItem('obito')
              this.form_resp = {};
              this.resp = [];
              this.$_ACTIONS_showSnackbarMessage({
                message: body.message || "Consulta salva com sucesso",
                color: "sucess",
              });
              this.$emit("close");
              this.$emit("reloadConsultas");
              this.$emit("finalizarConsulta", {
                msg: body.message,
                cor: "sucess",
                nome: this.paciente.nome,
                consultaId: ~~body.data.consulta_id,
              });
              // this.$router.replace({ name: "filas-atendimento-medico" });
              this.$router.replace("filas-atendimento-medico");
            } else {
              this.$_ACTIONS_showSnackbarMessage({
                message:
                  body.message || this.$global.messages.internalServerError,
                color: "error",
              });
            }
          },
          onError: (message) => {
            this.$_ACTIONS_showSnackbarMessage({
              message: message || this.$global.messages.internalServerError,
              color: "error",
            });
          },
          onEnd: () => {
            this.idRequisicao = "";
            this.loadingNovoFormulario = false;
          },
        },
        this.form_resp
      );
    },
    getDate(data) {
      if (data) {
        const arrDate = data.split("-");
        return `${arrDate[2]}/${arrDate[1]}/${arrDate[0]}`;
      } else {
        return "-";
      }
    },
    loadingForm() {
      this.loadingFormulario = true;
      const formularioService = new FormularioService();
      this.form = {};
      formularioService.get(
        {
          onSucess: (status) => (body) => {
            if (status === 200) {
              this.form.titulo = body.data.titulo;
              this.form.descricao = body.data.descricao;
              this.form.id_medico = body.data.id_medico;
              this.form.perguntas = body.data.perguntas
                .filter((pergunta) => pergunta.ativo)
                .sort((a, b) => {
                  if (a.ordem < b.ordem) return -1;
                  if (a.ordem > b.ordem) return 1;
                  return 0;
                });
              this.loadingFormulario = false;
            } else {
              this.$_ACTIONS_showSnackbarMessage({
                message: this.$global.messages.internalServerError,
                color: "error",
              });
            }
          },
          onError: (error) => {
            // this.$emit("close", { error });
            console.log(error);
          },
          onEnd: () => {},
        },
        // this.info.idFormulario
        this.idFormulario
      );
    },
  },
};
</script>

<style scoped>
.btn-cancelar {
  color: #6c757d;
}

.btn-padding {
  padding-left: 2rem;
  padding-right: 2rem;
}
</style>

<style>
#ModalIniciarConsulta .v-input--is-disabled,
#ModalIniciarConsulta .v-input--is-disabled:hover,
#ModalIniciarConsulta .v-input--is-readonly,
#ModalIniciarConsulta .v-input--is-readonly:hover {
  pointer-events: initial !important;
}

#ModalIniciarConsulta .v-input--is-disabled textarea:hover,
#ModalIniciarConsulta .v-input--is-disabled input:hover,
#ModalIniciarConsulta .v-input--is-readonly input:hover {
  cursor: no-drop !important;
}

.checkbox-no-rotate .v-icon {
  transform: rotate(0) !important;
}
.theme--light.v-label {
  color: rgba(0, 0, 0, 0.9) !important;
}
.d-flex {
  padding: 0.4rem;
}
</style>
